import { createFileRoute } from '@tanstack/react-router';
import { LegalPage } from '../components/legal-page';

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});

function TermsPage() {
  return (
    <LegalPage
      title="Terms of Service"
      lead="Terms of Service in preparation."
    >
      <p>
        Our Terms of Service are being drafted with our healthcare counsel and will be posted here before
        first customer go-live.
      </p>
      <p>
        Available in working-draft form on request — email{' '}
        <a className="text-primary underline" href="mailto:hello@lynrx.co">
          hello@lynrx.co
        </a>
        .
      </p>
    </LegalPage>
  );
}
